// extracted by mini-css-extract-plugin
export default {"actionButton":"setFirstPasswordSuccessPage_actionButton__G9R9H"};